import React, { useEffect, useState } from 'react';
import { getAuth, onAuthStateChanged } from 'firebase/auth';
import { collection, query, where, getDocs } from 'firebase/firestore';
import { db } from '../firebase';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';

function ProfilePage() {
  const [user, setUser] = useState(null);
  const [sessions, setSessions] = useState([]);

  useEffect(() => {
    const auth = getAuth();
    const unsubscribe = onAuthStateChanged(auth, async (currentUser) => {
      if (currentUser) {
        setUser(currentUser);
        try {
          const sessionsRef = collection(db, 'sessions');
          const q = query(sessionsRef, where('userId', '==', currentUser.uid));
          const snapshot = await getDocs(q);
          const sortedSessions = snapshot.docs
            .map((doc) => ({ id: doc.id, ...doc.data() }))
            .sort((a, b) => a.date.localeCompare(b.date));

          setSessions(sortedSessions);
        } catch (error) {
          console.error('Error fetching sessions:', error);
        }
      } else {
        setUser(null);
      }
    });

    return () => unsubscribe();
  }, []);

  const displayName = user?.displayName || user?.email || 'Client';

  return (
    <div className="min-h-screen bg-white">
      <Navbar />

      <div className="max-w-7xl mx-auto px-6 py-24 flex flex-col md:flex-row gap-10">
        {/* Sidebar */}
        <aside className="w-full md:w-1/4 space-y-8">
          {/* Profile Photo + Name */}
          <div className="text-center">
            {user?.photoURL && (
              <img
                src={user.photoURL}
                alt="Profile"
                className="w-32 h-32 rounded-full mx-auto object-cover border"
              />
            )}
            <h2 className="text-xl font-bold mt-4">{displayName}</h2>
          </div>

          {/* Coaching Navigation */}
          <div>
            <p className="font-semibold text-gray-700 mb-2">📘️ Coaching Navigation</p>
            <ul className="space-y-1 text-sm text-gray-600 pl-2">
            <a href='/dashboard'>
              <li>Home ➔ </li>
              </a>
            
            </ul>
          </div>

          {/* Admin Section
          <div>
            <p className="font-semibold text-gray-700 mb-2">🛠️ Admin & Management</p>
            <ul className="space-y-1 text-sm text-gray-600 pl-2">
              <li>➔ Payments & Contracts</li>
              <li>➔ Resources</li>
            </ul>
          </div> */}
        </aside>

        {/* Main Content */}
        <main className="flex-1 space-y-10">
          {/* Welcome Card */}
          <div className="border rounded-lg p-6 bg-gray-50">
            <p className="text-sm text-gray-800 font-medium mb-2">✨ Hey, Welcome {displayName}!</p>
            <p className="text-gray-700 text-sm mb-4">
              Hello and welcome! I'm thrilled to have you here and excited to be part of your journey toward your objectives.
              This portal is designed to be your go-to resource throughout our coaching experience.
            </p>
            <p className="text-sm text-pink-600 underline mb-2">
              <a href="#">Here’s what you can expect:</a>
            </p>
            <ul className="text-sm text-gray-700 list-disc pl-5 space-y-1">
              <li><span className="font-semibold">Personalized Coaching:</span> Access notes, resources, & action plans.</li>
              <li><span className="font-semibold">Progress Tracking:</span> Stay motivated by keeping an eye on your milestones and accomplishments.</li>
              <li><span className="font-semibold">Communication:</span> Reach out through our messaging system.</li>
            </ul>
          </div>

          {/* Project Following / Modules */}
          <section>
            <h2 className="text-sm text-gray-600 font-semibold mb-4">📁 Upcoming and past calls</h2>
            <div className="grid grid-cols-2 sm:grid-cols-4 gap-4">
              {sessions.length === 0 ? (
                <p className="text-sm text-gray-400">No booked sessions yet.</p>
              ) : (
                sessions.map((session) => (
                  <div
                    key={session.id}
                    className="aspect-square border border-dashed border-gray-300 bg-gray-50 flex flex-col items-center justify-center text-sm font-semibold text-gray-700 rounded-md text-center p-2"
                  >
                    <p>{session.type}</p>
                    <p className="text-xs text-gray-500">{session.date} @ {session.time}</p>
                  </div>
                ))
              )}
            </div>
          </section>
        </main>
      </div>

      <Footer />
    </div>
  );
}

export default ProfilePage;
